import { client } from './client';
import type { LoginRequest, LoginResponse, MeResponse, ChangePasswordRequest } from '../types/auth';

export const authApi = {
  login: (data: LoginRequest) =>
    client.post<LoginResponse>('/api/v1/auth/login', data),

  logout: () =>
    client.post<void>('/api/v1/auth/logout'),

  me: () =>
    client.get<MeResponse>('/api/v1/auth/me'),

  changePassword: (data: ChangePasswordRequest) =>
    client.put<void>('/api/v1/auth/password', data),
};
